import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MediaCaptureRoutingModule } from './media-capture-routing.module';
import { FaceCaptureComponent } from './components/face-capture/face-capture.component';
import { MediaCaptureComponent } from './media-capture.component';
import { KamonaModule } from '@mpt-fo/common/kamona/kamona.module';


@NgModule({
	declarations: [
		FaceCaptureComponent,
		MediaCaptureComponent,
	],
	exports: [
		FaceCaptureComponent,
	],
	imports: [
		CommonModule,
		MediaCaptureRoutingModule,
		KamonaModule,
	]
})
export class MediaCaptureModule {
}
